"use client";

import { motion } from "framer-motion";
const trainers = [{
  name: "Céline Chadelat et Marie Mahé-Poulin",
  description: "co-autrices et fondatrices de la formation Le Mois d’Or"
}, {
  name: "Jaques Dayan",
  description: "professeur en pédopsychiatrie"
}, {
  name: "Ingrid Bayot",
  description: "Sage-femme et formatrice en périnatalité et allaitement"
}, {
  name: "Dr Bernadette de Gasquet",
  description: "Médecin et professeur de yoga"
}, {
  name: "Delphine Petit-Postma",
  description: "Kraamzorg"
}, {
  name: "Candice Levy",
  description: "Naturopathe"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export default function TrainersMinimalistList() {
  return;
}